!(function () {
  "use strict";
  var t,
    n = {
      5500: function (t, n, e) {
        var o = e(6358);
        if (
          document.body.classList.contains("template-index") &&
          window.innerWidth > 768
        ) {
          var r = document.body,
            a = document.documentElement,
            i = document.getElementById("logo"),
            c = i.getBoundingClientRect(),
            s = c.bottom,
            l = function () {
              return window.innerHeight > 775
                ? (0.91 * window.innerWidth) / 146
                : (window.innerWidth) / 146;
            };
          (i.style.transform = "translateX(-50%) scale(".concat(l(), ")")),
            (c = i.getBoundingClientRect());
          var u = window.innerHeight - c.bottom - 10;
          i.style.transform = "translateX(-50%) scale("
            .concat(l(), ") translateY(")
            .concat(u / l(), "px)");
          var d = (c = i.getBoundingClientRect()).bottom - s,
            f = function () {
              var t = r.scrollTop || a.scrollTop;
              if (t < d) {
                var n = l() - (t / d) * (l() - 1),
                  e = u - (t / d) * u;
                window.innerWidth > 768
                  ? (i.style.transform = "translateX(-50%) scale("
                      .concat(n, ") translateY(")
                      .concat(e / n, "px)"))
                  : o.p8.to(i, {
                      css: {
                        transform: "translateX(-50%) scale("
                          .concat(n, ") translateY(")
                          .concat(e / n, "px)"),
                      },
                      duration: 0.2,
                    }),
                  window.dispatchEvent(
                    new CustomEvent("updatenavstatus", {
                      detail: { navStatus: !1 },
                    })
                  );
              } else
                (i.style.transform = "translateX(-50%) scale(".concat(
                  1,
                  ") translateY(",
                  0,
                  "px)"
                )),
                  window.dispatchEvent(
                    new CustomEvent("updatenavstatus", {
                      detail: { navStatus: !0 },
                    })
                  );
            };
          f(),
            window.addEventListener("scroll", function () {
              f();
            }),
            window.addEventListener("resize", function () {
              f();
            });
        } else
          window.dispatchEvent(
            new CustomEvent("updatenavstatus", { detail: { navStatus: !0 } })
          );
      },
    },
    e = {};
  function o(t) {
    var r = e[t];
    if (void 0 !== r) return r.exports;
    var a = (e[t] = { id: t, loaded: !1, exports: {} });
    return n[t].call(a.exports, a, a.exports, o), (a.loaded = !0), a.exports;
  }
  (o.m = n),
    (t = []),
    (o.O = function (n, e, r, a) {
      if (!e) {
        var i = 1 / 0;
        for (u = 0; u < t.length; u++) {
          (e = t[u][0]), (r = t[u][1]), (a = t[u][2]);
          for (var c = !0, s = 0; s < e.length; s++)
            (!1 & a || i >= a) &&
            Object.keys(o.O).every(function (t) {
              return o.O[t](e[s]);
            })
              ? e.splice(s--, 1)
              : ((c = !1), a < i && (i = a));
          if (c) {
            t.splice(u--, 1);
            var l = r();
            void 0 !== l && (n = l);
          }
        }
        return n;
      }
      a = a || 0;
      for (var u = t.length; u > 0 && t[u - 1][2] > a; u--) t[u] = t[u - 1];
      t[u] = [e, r, a];
    }),
    (o.d = function (t, n) {
      for (var e in n)
        o.o(n, e) &&
          !o.o(t, e) &&
          Object.defineProperty(t, e, { enumerable: !0, get: n[e] });
    }),
    (o.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (t) {
        if ("object" == typeof window) return window;
      }
    })()),
    (o.o = function (t, n) {
      return Object.prototype.hasOwnProperty.call(t, n);
    }),
    (o.nmd = function (t) {
      return (t.paths = []), t.children || (t.children = []), t;
    }),
    (o.j = 805),
    (function () {
      var t = { 805: 0 };
      o.O.j = function (n) {
        return 0 === t[n];
      };
      var n = function (n, e) {
          var r,
            a,
            i = e[0],
            c = e[1],
            s = e[2],
            l = 0;
          if (
            i.some(function (n) {
              return 0 !== t[n];
            })
          ) {
            for (r in c) o.o(c, r) && (o.m[r] = c[r]);
            if (s) var u = s(o);
          }
          for (n && n(e); l < i.length; l++)
            (a = i[l]), o.o(t, a) && t[a] && t[a][0](), (t[a] = 0);
          return o.O(u);
        },
        e = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      e.forEach(n.bind(null, 0)), (e.push = n.bind(null, e.push.bind(e)));
    })();
  var r = o.O(void 0, [216], function () {
    return o(5500);
  });
  r = o.O(r);
})();
